import {appBottomScheme, getCookie, hrefSSO, isBottomFn, openTalk} from "@COMPONENTS/common/commonUtil";
import ErrorBoundary from "@COMPONENTS/common/error/ErrorBoundary";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import useCustomerMe from "@QUERIES/account/useCustomerMe";
import useGlobalMenu, {GlobalMenu} from "@QUERIES/bff/global/useGlobalMenu";
import useGetRecently from "@QUERIES/essential/user/useGetRecently";
import styled from "@yb/styled-px2rem";
import {device} from "@yb/utils";
import {useRouter} from "next/router";
import {useCallback, useEffect, useState} from "react";

const Wrap = styled.div``;

const Gnb = styled.div<{$show: boolean}>`
	position: fixed;
	left: 0;
	z-index: 10;
	width: 100%;
	height: auto;
	background-color: #fff;

	> button {
		display: none;
	}

	${props =>
		props.$show
			? `
        bottom: 0px;
        visibility: visible;
        > button {
            display: block;
        }
    `
			: `
        bottom: -50px;
        visibility: hidden;
    `}
`;

const TopBtn = styled.button<{$show?: boolean}>`
	position: relative;
	z-index: 100;
	width: 36px;
	height: 36px;
	border: 1px solid #bbb;
	border-radius: 50%;
	background-color: #fff;
	opacity: 0;
	animation: fadeout 0.4s;

	&::before {
		position: absolute;
		top: 50%;
		left: 50%;
		display: block;
		width: 13px;
		height: 15px;
		background: url(https://cimgcdn.ybtour.co.kr/common/ico/ico_top_m.png);
		background-position: center;
		background-size: 13px 15px;
		background-repeat: no-repeat;
		transform: translate(-50%, -50%);
		content: "";
	}

	${props =>
		props.$show &&
		`
            opacity: 1;
            animation: fadein 0.4s;
    `}

	@keyframes fadein {
		0% {
			opacity: 0;
		}
		100% {
			opacity: 1;
		}
	}
	@keyframes fadeout {
		0% {
			opacity: 1;
		}
		100% {
			opacity: 0;
		}
	}
`;

const GnbBar = styled.div`
	border-top: 1px solid #ddd;
`;

const GnbList = styled.ul`
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 50px;
	padding: 0 15px;
	> li {
		position: relative;
		display: flex;
		align-items: center;
		height: 50px;
		> span {
			position: absolute;
			width: 1px;
			height: 1px;
			padding: 0;
			margin: -1px;
			border: none;
			overflow: hidden;
			clip: rect(0 0 0 0);
		}
	}
`;

const Icon = styled.i<{$isActive: boolean; $menu: string}>`
	display: block;
	width: 24px;
	height: 24px;
	&::before,
	&::after {
		position: absolute;
		display: block;
		width: 24px;
		height: 24px;
		background: url(https://cimgcdn.ybtour.co.kr/common/ico/ico_bottom.png);
		background-size: 120px 48px;
		background-repeat: no-repeat;
		content: "";
		${props => {
			if (props.$menu === "home") {
				return `background-position-x: 0;`;
			}
			if (props.$menu === "menu") {
				return `background-position-x: -24px;`;
			}
			if (props.$menu === "search") {
				return `background-position-x: -48px;`;
			}
			if (props.$menu === "mypage") {
				return `background-position-x: -72px;`;
			}
			if (props.$menu === "recent") {
				return `background-position-x: -96px;`;
			}
		}}
	}
	&::before {
		z-index: 2;
		visibility: hidden;
		background-position-y: 0;
	}
	&::after {
		z-index: 1;
		visibility: visible;
		background-position-y: -24px;
	}

	${props =>
		props.$isActive &&
		`
			animation : bounce-in 1s;
			&::before {
				animation: reveal 0.3s forwards;
				animation-delay: 1s;
			}
			&::after {
				animation: fade-out 1s forwards;
				animation-delay: 1s;
			}
		`}

	@keyframes fade-out {
		0% {
			visibility: visible;
		}

		100% {
			visibility: hidden;
		}
	}

	@keyframes reveal {
		0% {
			visibility: visible;
			clip-path: inset(100% 0 0 0);
		}

		100% {
			visibility: visible;
			clip-path: inset(0 0 0 0);
		}
	}

	@keyframes bounce-in {
		0% {
			transform: scale(1);
		}
		10% {
			transform: scale(1.1);
		}
		20% {
			transform: scale(0.9);
		}
		40% {
			transform: scale(1);
		}
		50% {
			transform: scale(0.9);
		}
		60% {
			transform: scale(1.1);
		}
		70% {
			transform: scale(1);
		}
	}
`;

const Thumbnail = styled.div`
	width: 26px;
	height: 26px;
	border-radius: 6px;
	overflow: hidden;
	border: 1px solid #bbb;
	box-sizing: border-box;
	> img {
		width: 100%;
		height: 100%;
	}
`;

const FloatingBlock = styled.div`
	position: fixed;
	right: 15px;
	bottom: 62px;
	z-index: 100;
`;

const TalkWrap = styled.div<{$show?: boolean}>`
	position: fixed;
	right: 15px;
	bottom: 62px;
	z-index: 105;
	transition: bottom 0.4s;
	${props =>
		props.$show &&
		`
		bottom: 108px;
	`}
`;

const TalkBtn = styled.button`
	position: relative;
	z-index: 105;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 4px;
	width: 50px;
	height: 50px;
	border-radius: 50%;
	background-color: #ffce3c;
	cursor: pointer;

	&:before {
		display: block;
		width: 18px;
		height: 20px;
		background-image: url(https://cimgcdn.ybtour.co.kr/common/ico/ico_chatbot.png);
		background-repeat: no-repeat;
		background-size: contain;
		content: "";
	}
	&:after {
		display: inline-block;
		content: "상담";
		font-family: "PT-bold";
		font-size: 11px;
		letter-spacing: -0.025em;
		color: #111;
	}
`;

const Floating = () => {
	const router = useRouter();
	/** 로그인 */
	const signin = useCustomerMe();
	const isSignin = signin.data?.body.nonUser === false;
	const webCustNo = signin.data?.body.webCustNo || "";

	/** 최근 본 상품 ID */
	const userId = getCookie("userId") || (window.ensureUserHasUniqueId ? window.ensureUserHasUniqueId() : "");

	/** 최근 본 리스트 */
	const recentlyListFetch = useGetRecently(userId, webCustNo, {
		enabled: !signin.isFetching && !!userId,
		throwOnError: false,
	});
	const recentlyList = recentlyListFetch.data?.body?.productResultList || [];

	const createRedirect =
		(path = "", type: "PKG" | "MAIN" = "PKG") =>
		() => {
			let domain = publicRuntimeConfig.ENV_PACKAGE_M_URL;
			if (type === "MAIN") domain = publicRuntimeConfig.ENV_PORTAL_URL;
			hrefSSO(`${domain}${path}`);
		};

	const home = createRedirect("", "MAIN");
	const menu = createRedirect("/m/sitemap", "MAIN");
	const search = createRedirect("/common/searchGoods.yb");
	const recent = createRedirect("/common/recentlyView.yb");
	const mypage = () => {
		const goUrl = `${publicRuntimeConfig.ENV_PACKAGE_M_URL}/mypage/index.yb`;
		if (isSignin) {
			hrefSSO(goUrl);
		} else {
			LoginUtil.login(goUrl);
		}
	};
	const bottomList = [
		{title: "홈", menu: "home", clickEvent: home},
		{title: "목록", menu: "menu", clickEvent: menu},
		{title: "검색", menu: "search", clickEvent: search},
		{title: "마이 페이지", menu: "mypage", clickEvent: mypage},
		{title: "최근 본 상품", menu: "recent", clickEvent: recent},
	];

	/** publish */
	const [isActive, setIsActive] = useState(null);
	const [showGnb, setShowGnb] = useState(true);
	const [position, setPosition] = useState(0);
	const [show, setShow] = useState(false);

	const toggleActive = (index: number) => {
		setIsActive(index);
	};

	const scrollLocation = useCallback(() => {
		const scroll = document.querySelector("html").scrollTop;
		if (scroll < 60) {
			setShow(false);
		} else {
			setShow(position > scroll);
			setPosition(scroll);
		}
		const currentScrollTop = window.scrollY || document.documentElement.scrollTop;
		if (currentScrollTop > position) {
			setShowGnb(false);
		} else {
			setShowGnb(true);
		}
	}, [position]);

	useEffect(() => {
		window.addEventListener("scroll", scrollLocation);
		return () => {
			window.removeEventListener("scroll", scrollLocation);
		};
	}, [router, position]);

	const top = () => {
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	};
	/** //publish */

	/** 바텀바 여부 (제휴, 일정표) */
	const isBottom = isBottomFn(router);

	/** bottom bar app scheme 처리 */
	const [isApp, setIsApp] = useState(true);
	useEffect(() => {
		const ybapp = device.isYBApp();
		if (!ybapp) setIsApp(ybapp);
	}, [router]);

	useEffect(() => {
		appBottomScheme(isBottom);
	}, [isApp, isBottom]);

	/** 해피톡 */
	const [talk, setTalk] = useState<GlobalMenu | null>(null);
	const globalMenuFetch = useGlobalMenu();
	const globalMenu = globalMenuFetch.data?.body;
	useEffect(() => {
		if (!router.query.dspSid || !router.pathname.includes("/product/localList") || !globalMenu) return;
		const target = globalMenu.menuLv3List.find(v => v.dspSid === router.query.dspSid && v.talkYn === "Y") || null;
		if (target) setTalk(target);
	}, [router.pathname, router.query.dspSid, globalMenu]);

	return (
		<>
			<ErrorBoundary logMsg="Floating Error">
				<Wrap>
					{isBottom && !isApp && (
						<Gnb $show={showGnb}>
							<GnbBar>
								<GnbList>
									{bottomList.map((item, index) => (
										<li
											onClick={() => {
												toggleActive(index);
												item.clickEvent();
											}}
											key={item.menu + index}
										>
											{item.menu === "recent" && recentlyList.length > 0 ? (
												<Thumbnail>
													<img src={recentlyList[0].imgUrl} alt="최근 본 상품 이미지" />
												</Thumbnail>
											) : (
												<Icon $isActive={isActive === index} $menu={item.menu} />
											)}
											<span>{item.title}</span>
										</li>
									))}
								</GnbList>
							</GnbBar>
						</Gnb>
					)}
					<FloatingBlock>
						{/* 해피톡 */}
						{talk && (
							<TalkWrap $show={show}>
								<TalkBtn onClick={() => openTalk(talk.talkUrl)}>
									<span>해피톡 상담</span>
								</TalkBtn>
							</TalkWrap>
						)}
						<TopBtn $show={show} onClick={top} />
					</FloatingBlock>
				</Wrap>
			</ErrorBoundary>
		</>
	);
};

export default Floating;
